import React, { useEffect, useState } from 'react';
import Portfolio from './Portfolio';
// import PageBanner from '../CommonPages/PageBanner';
// import Loader from '../Shared/Loader';
import { Link } from 'react-router-dom';
import MyLoader from '../Shared/MyLoader';

const Project = () => {
    
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        // Simulate an API call
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
        setTimeout(() => {
            setIsLoading(false);
        }, 1500);
    }, []);

    if (isLoading) {
        // return <Loader/>;
        return <MyLoader/>;
    }

    return (
        <>
           
           
                {/* <PageBanner title="Projects" activePage="Projects"></PageBanner> */}
                <div className="page_header">
                    <div className="page_header_inner project_breadcrumb" >
                        <div className="container">
                            <div className="page_header_content d-flex align-items-center justify-content-between">
                                <h2 className="heading">Projects</h2>
                                <ul className="breadcrumb d-flex align-items-center">
                                    <li><Link to="/">Home</Link></li>
                                    <li className="active">Projects</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <Portfolio text='Load More' className='btn gray' />
          
        </>
    );
};

export default Project;